export class ReconnectRestoreAccountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReconnectRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
